<app-header #appHeaderComponent [title]="headerTitle" [menuPages]="menuPages" [actionButtons]="actionButtons"
  [navLine1]="dateText" [navLine2]="paginationText" [isTreatmentPage]="true" [showAdjustDeviceControls]="showAdjustDeviceControls"
  [showDeviceSessionMessages]="isAdjustSelected && showAdjustDeviceControls"
  [showCurrentVisitBadge]="showCurrentVisitBadge"
  [onClose]="closeProfile.bind(this)"
  [onNext]="adjustNavNext.bind(this)" [onPrev]="adjustNavPrevious.bind(this)"
  [navDisabledPrev]="navDisabledPrev" [navDisabledNext]="navDisabledNext"
  [navigationEnabled]="navigationEnabled"
  [statusBanner]="editModeBanner"
  [allowWebConnectButton]="allowWebConnectButton">
</app-header>

@if(patientModel){
  <ion-content>
    @if (isProfileSelected) {
      <app-treatment-profile #profileComponent [patient]="patientModel" [hasPatientWritePermission]="hasPatientWritePermission"
        [supportsFullAdjust]="supportsFullAdjust"
        [currentQueuedTreatmentId]="currentQueuedTreatmentId"
        (adjustSelected)="LoadAdjustComponent()"
        (onEncounterItemClicked)="OpenEncounter($event)" (onProfileUpdated)="onProfileUpdated($event)">
      </app-treatment-profile>
    }
    @if (isAdjustSelected ) {
      <app-treatment-adjust #adjustmentComponent [patientModel]="patientModel"
        [metadataEditOnly]="isMetadataEditOnly"
        [queuedParts]="queuedTreatmentParts"
        [queuedTreatmentNotes]="queuedTreatmentTreatmentNotes"
        [queuedRegionNotes]="queuedTreatmentRegionNotes"
        [queuedNotes]="queuedTreatmentNotes"
        (treatmentCompleted)="onTreatmentCompleted($event)" (duplicateTreatmentReady)="duplicateTreatmentReady()"
        (onTreatmentDataChanged)="treatmentDataChanged($event)">
      </app-treatment-adjust>
    }
    @if (isReviewSelected) {
      <app-treatment-review #reviewComponent [patientModel]="patientModel" 
        (treatmentCompleted)="onTreatmentCompleted($event)" (setRecallEnabled)="setRecallEnabled($event)"
        (onRecallClicked)="onRecallClicked()" (duplicateTreatmentReady)="duplicateTreatmentReady()"
        (onTreatmentDataChanged)="treatmentDataChanged($event)"
        (onSetCompleteTreatmentEnabled)="onSetCompleteTreatmentEnabled($event)">
      </app-treatment-review>
    }
    @if (isResultSelected) {
      <app-treatment-result></app-treatment-result>
    }
  </ion-content>
}